<!--pages/commission/index.wxml-->
<template>
  <!--pages/commission/index.wxml-->
<div class="commission-page scroll-view" v-scroll-bottom="loadMoreData">
    <div class="bg-commission"></div>
      <div class="price-wrap">
          <div class="price-label commission-label"><span>本月实际结算金额</span></div>
          <div class="price-val">
            <span class="price-num">{{comissionInfo.currentMonthSettlement && comissionInfo.currentMonthSettlement.status == 1? "￥" + comissionInfo.currentMonthSettlement.hkjActualFee:"每月20号后出结算账单"}}</span>
          </div>
          <div class="price-action">
            <div class="price-action-col"></div>
            <div class="price-action-col">
              <div class="tixian-wrap">
                <span class="to-bank-btn">{{comissionInfo.currentMonthSettlement ? (comissionInfo.currentMonthSettlement.status==1 ? "财务已审核" : "已结算待审核"):"未开始结算"}}</span>
                <span v-if="comissionInfo.currentMonthSettlement && comissionInfo.currentMonthSettlement.status==1" class="records" @click="handleRecord">查看明细</span>
              </div>
            </div>
          </div>
          <div class="price-footer">
            <div class="now-wrap">
              <div class="commission-label-wrap">
                <span class="commission-label">本月预估结算收入</span>
              </div>
              <div class="commission-val-wrap">
                ￥<span class="commission-val">{{comissionInfo.preMonthEstimateFee}}</span>
              </div>
              <div class="commission-history-wrap">
                <span class="commission-history" @click="handleRecord">历史结算账单</span>
              </div>
            </div>
            <div class="next-wrap">
              <div class="commission-label-wrap">
                <span class="commission-label">下月预估结算收入</span>
              </div>
              <div class="commission-val-wrap">
                ￥<span class="commission-val">{{comissionInfo.currentMonthEstimateFee}}</span>
              </div>
              <div class="commission-history-wrap">
                <span class="commission-history">待结算</span>
              </div>
            </div>
          </div>
        </div>
    <div class="">
    <div class="commission-wrap">
        <div class="commission-list">
            <div class="commission-item arrow_comission">
                <div class="title" @click="orderPage">
                    <span class="order-detail">全部订单明细</span>
                    <span class="hot">HOT</span>
                </div>
            </div>
            <div class="commission-item">
                <div class="title">
                    <span class="order-detail">本月预估佣金</span>
                </div>
                <div class="other">
                    <span class="other-title">￥{{comissionInfo.currentEstimateFee}}</span>
                </div>
            </div>
        </div>
        <div class="commission-list">
            <div class="commission-head">
                <div class="head-title">
                    <span>预估佣金订单</span>
                </div>
                <!-- <div class="more">
                    <span>更多</span>
                </div> -->
            </div>
            <div class="commission-content">
                <div class="filter-wrap">
                    <button @click="onTapFilter('currentMonth')" class="filter-btn" :class="filter=='currentMonth'?'active':''">本月</button>
                    <button @click="onTapFilter('today')" id="123" class="filter-btn" :class="filter=='today'?'active':''">今天</button>
                    <button @click="onTapFilter('yesterday')" class="filter-btn" :class="filter=='yesterday'?'active':''">昨天</button>
                    <button @click="onTapFilter('last7days')" class="filter-btn" :class="filter=='last7days'?'active':''">近7天</button>
                    
                </div>
                <!-- <div class="total-wrap">
                    <div class="click-total">
                        <div class="total-title">点击量</div>
                        <div class="total-value">0</div>
                    </div>
                    <div class="uv-total">
                        <div class="total-title">引入UV</div>
                        <div class="total-value">0</div>
                    </div>
                </div> -->
            </div>
        </div>
        <order-list mode="order" :order-list="orderList" :has-more="hasMore"></order-list>
    </div>
    </div>
    <div @click="toggleTooltip" class="tooltip" v-if="isTooltipVisible">
        <div class="tooltip-span">本月实际结算收入：订单完成时间截止到上月底未结算的CPS推广佣金（减去退货等逆向的佣金）。</div>
        <div class="tooltip-span">本月预估结算收入：
            下单时间在上月时间范围内，已付款且已完成且状态正常订单的预估佣金之和，如果订单发生了退款退货则数值可能发生变化
</div>
        <div class="tooltip-span">下月预估结算收入：下单时间在本月时间范围内，已付款且已完成且状态正常订单的预估佣金之和，如果订单发生了退款退货则数值可能发生变化</div>
        <div class="tooltip-span">本月预估佣金：下单时间在本月时间范围内订单状态为已付款或已完成订单佣金之和。</div>
        <div class="tooltip-span">实际佣金须等待订单完成之后计算展示。</div>
        <div>官方拥有最终解释权，如有疑问联系客服</div>
    </div>
    <div class="question-icon" @click="toggleTooltip">
        ?
    </div>
</div>
</template>
<script>
import OrderList from '@/components/list/OrderList.vue'
import { getOrderList } from '@/helpers/orderHelper'
import { getCommission } from '@/services/order'
// getOrderList
export default {
  name: 'CommissionView',
  components: {
    OrderList
  },
  data() {
    return {
      filter: "currentMonth",
      orderList: [],
      hasMore: false,
      page: 1,
      status: [16,17],
      comissionInfo: {
        currentMonthSettlement: {
            status: ''
        },
        preMonthEstimateFee: '',
        currentMonthEstimateFee: '',
        currentEstimateFee: ''
      },
      isTooltipVisible: false,
      type: 'loading',
      message: ''
    }
  },
  created() {
    getCommission().then(res => {
      this.comissionInfo = res.data
    })
    getOrderList(this)
  },
  methods: {
    orderPage() {
      this.$router.push('/order')
    },
    loadMoreData() {
      if (this.hasMore) {
          this.page++
          getOrderList(this)
      }
    },
    handleRecord() {
        this.$router.push('/historyrecord')
    },

    onTapFilter(filter) {
        this.filter = filter
        this.page = 1
        this.orderList = []
        getOrderList(this)
    },
    toggleTooltip: function () {
      this.isTooltipVisible = !this.isTooltipVisible
    }
  }
}
</script>
<style scoped>
/* pages/commission/index.wxss */
.commission-page {
    position: relative;
}

.price-wrap {
    color: white;
    height: var(--len210);
    padding: 0 var(--len30) 0 var(--len30);
    position: relative;
    z-index: 9;
    /* background-color: rgba(0, 0, 0, 0.05); */
}

.commission-val-wrap {
    height: var(--len40);
    line-height: var(--len40);
    border-right: 0.5px solid white;
}

.commission-history-wrap {
    font-size: var(--len12);
}

.next-wrap {
    /* padding-left: 30px; */
}

.next-wrap .commission-val-wrap {
    border-right: none;
}

.next-wrap .commission-label-wrap,
.next-wrap .commission-val-wrap,
.next-wrap .commission-history-wrap {
    margin-left: var(--len30);
}

.commission-label {
    font-size: var(--len12);
}

.price-label,
.price-val {
    text-align: center;
}

.price-val {
    margin-top: var(--len5);
}

.price-num {

    text-align: center;
    /* font-weight: bold; */
    font-size: var(--len25);
}

.price-action {
    margin-top: var(--len5);
    display: flex;
}

.price-action-col {
    flex: 1;
}

.tixian-wrap {
    margin-left: var(--len_45);
}

.to-bank-btn {
    background-color: rgba(168, 114, 13, 0.7);
    width: var(--len90);
    display: inline-block;
    text-align: center;
    height: var(--len30);
    font-size: var(--len12);
    font-weight: normal;
    color: var(--primary-color);
    line-height: var(--len30);
    border-radius: var(--len30);
    padding: 0;
    margin: 0;
}

.records {
    margin-left: var(--len10);
    font-size: var(--len12);
    display: inline-block;
    position: relative;
    width: var(--len60);
}

.records::after {
    content: '';
    position: absolute;
    border-top: 1px solid white;
    border-right: 1px solid white;
    width: var(--len5);
    height: var(--len5);
    top: var(--len5);
    right: 0px;
    transform: rotate(45deg);
}

.price-footer {
    display: flex;
    margin-top: var(--len20);
}

.now-wrap,
.next-wrap {
    flex: 1;
    box-sizing: border-box;
}

.commission-history {
    display: inline-block;
    position: relative;
    width: var(--len80);
}

.now-wrap .commission-history::after {
    content: '';
    position: absolute;
    border-top: 1px solid white;
    border-right: 1px solid white;
    width:var(--len5);
    height: var(--len5);
    top: var(--len5);
    right: 0px;
    transform: rotate(45deg);
}

.bg-commission {
    background-color: var(--primary-color);
    height: var(--len210);
    width: 100%;
    border-bottom-right-radius: var(--len10);
    border-bottom-left-radius: var(--len10);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}


.commission-wrap {
    padding: var(--len10);
}

.commission-list {
    margin-bottom: var(--len10);
    padding: 0 var(--len10);
    border-radius: var(--len5);
    background-color: white;
}

.commission-item {
    border-bottom: .5px solid rgba(0, 0, 0, 0.1);
    /* padding: 0 10px; */
    display: flex;
    position: relative;
    height: var(--len40);
    justify-content: center;
    align-items: center;
}

.arrow_comission::after {
    content: '';
    position: absolute;
    border-top: 1px solid black;
    border-right: 1px solid black;
    width: var(--len8);
    height: var(--len8);
    top: var(--len16);
    right: 0px;
    transform: rotate(45deg);
}

.commission-item .title {
    font-size: var(--len14);
    color: black;
    flex: 1;
}

.commission-item .title .hot {
    margin-left: var(--len5);
    background-color: var(--primary-color);
    padding: 0 var(--len5);
    border-radius: var(--len14);
    height: var(--len14);
    line-height: var(--len14);
    font-size: var(--len12);
    color: white;
}

.commission-item:last-child {
    border: none;
}

.commission-item .other {
    font-size: var(--len12);
    text-align: right;
    width: var(--len100);
    margin-right: var(--len10);
}

.commission-head {
    padding-top: var(--len10);
    display: flex;
    /* padding: 0 10px; */
}

.commission-head .head-title {
    font-size: var(--len14);
    flex: 1;
}

.commission-head .more {
    position: relative;
    font-size: var(--len12);
    width: var(--len30);
}

.commission-head .more::after {
    content: '';
    position: absolute;
    border-top: 1px solid black;
    border-right: 1px solid black;
    width: var(--len5);
    height: var(--len5);
    top: var(--len5);
    right: 0px;
    transform: rotate(45deg);
}

.commission-content {
    /* padding: 0 10px; */
    padding: var(--len10) 0; 
}

.commission-content .filter-wrap {
    /* padding-top: 10px;
    padding-bottom: 10px; */
    display: flex;
}

.commission-content .filter-wrap button {
    font-weight: normal;
    background-color: rgba(0, 0, 0, 0.1);
    /* border: 1px solid rgba(0, 0, 0, 0.1); */
    font-size: var(--len12);
    text-align: center;
    padding: 0 var(--len10);
    height: var(--len25);
    line-height: var(--len25);
    border-radius: var(--len25);
    margin-right: var(--len25);
}

.commission-content .filter-wrap button:last-child {
    margin-right: 0;
}

.commission-content .filter-wrap button.active {
    color: var(--primary-color);
    border: 1px solid var(--primary-color);
    background-color: rgba(255, 165, 0, 0.3);
}

.total-wrap {
    margin-top: var(--len10);
    display: flex;
}

.total-wrap .click-total {
    width: var(--len120);
}

.total-wrap .uv-total {
    flex: 1;
}

.total-wrap .total-title {
    font-size: var(--len12);
    color: gray;
}

.total-wrap .total-value {
    font-size: var(--len12);
    color: black;
    font-weight: bold;
    margin-top: var(--len5);
}

.question-icon {
    position: absolute; 
    top: var(--len12); 
    right: var(--len16); 
    width: var(--len25); 
    height: var(--len25); 
    line-height: var(--len25);
    text-align: center; 
    font-size: var(--len14);
    font-weight: bold;
    color: var(--primary-color); 
    background-color: white; 
    border-radius: 50%; 
    box-shadow: 0 2px var(--len5) rgba(0, 0, 0, 0.2); 
    z-index: 999;
    cursor: pointer; 
  }

  .tooltip {
    position: absolute;
    top: var(--len5); /* 根据实际布局调整位置 */
    /* left: 16px; */
    background-color: rgba(0, 0, 0, 0.75);
    color: #fff;
    padding: var(--len8) var(--len12);
    border-radius: var(--len5);
    font-size: var(--len12);
    line-height: 1.5;
    box-shadow: 0 var(--len5) var(--len5) rgba(0, 0, 0, 0.2);
    z-index: 1000;
  }
  .tooltip-text {
    margin-bottom: var(--len16);
  }
</style>